/**
 * VISTOERA_GENERATE_VIDEO_CANONICAL_INPUT_PORTS_EDGE_DEDUP_AND_DOM_ANCHORED_HANDLE_REBUILD_P0_V2
 * §3 — single canonical Generate Video input port registry.
 *
 * React Flow Handle.id === Edge.targetHandle === drop zone slot ===
 * structured assignment slot. Historical aliases normalize at hydration
 * boundaries only (`canvasEdgeHandleHydration.ts`).
 */

import {
  GENERIC_INPUT_HANDLE,
  GENERATE_VIDEO_NODE_AGGREGATE_HANDLE,
  GENERATE_VIDEO_REFERENCE_ASSETS_AGGREGATE_HANDLE,
  VIDEO_AUDIO_REFERENCE_HANDLE,
  VIDEO_KEYFRAME_END_HANDLE,
  VIDEO_KEYFRAME_MIDDLE_HANDLE,
  VIDEO_KEYFRAME_START_HANDLE,
  VIDEO_ORIGINAL_PROMPT_IN_HANDLE,
  VIDEO_PROMPT_ENHANCEMENT_HANDLE,
  VIDEO_REFERENCE_VIDEO_HANDLE,
  videoKeyframeMiddleHandleId,
  videoStructuredAssetHandleId,
  type VideoStructuredAssetCategory,
} from './dataflow'

/** Canonical semantic port ids — the only names used inside the canvas runtime. */
export const VIDEO_INPUT_PORT = {
  KEYFRAME_START: VIDEO_KEYFRAME_START_HANDLE,
  KEYFRAME_MIDDLE: VIDEO_KEYFRAME_MIDDLE_HANDLE,
  KEYFRAME_END: VIDEO_KEYFRAME_END_HANDLE,
  CHARACTER: videoStructuredAssetHandleId('character'),
  PRODUCT: videoStructuredAssetHandleId('object'),
  SCENE: videoStructuredAssetHandleId('scene'),
  OTHER_REFERENCE: videoStructuredAssetHandleId('reference'),
  REFERENCE_VIDEO: VIDEO_REFERENCE_VIDEO_HANDLE,
  AUDIO_REFERENCE: VIDEO_AUDIO_REFERENCE_HANDLE,
  /** Upstream TEXT binds to original / editable prompt input — NOT enhancement. */
  PROMPT: VIDEO_ORIGINAL_PROMPT_IN_HANDLE,
  /** Enhancement RESULT from a bound GenerateText enhancer — action output, not prompt input. */
  ENHANCED_PROMPT: VIDEO_PROMPT_ENHANCEMENT_HANDLE,
  /** Legacy generic tray — normalize away when semantic port is known. */
  LEGACY_GENERIC: GENERIC_INPUT_HANDLE,
  NODE_AGGREGATE: GENERATE_VIDEO_NODE_AGGREGATE_HANDLE,
  REFERENCE_ASSETS_AGGREGATE: GENERATE_VIDEO_REFERENCE_ASSETS_AGGREGATE_HANDLE,
} as const

export type VideoInputPortId = (typeof VIDEO_INPUT_PORT)[keyof typeof VIDEO_INPUT_PORT]

export function videoInputPortForStructuredCategory(category: VideoStructuredAssetCategory, keyframeId?: string): string {
  return videoStructuredAssetHandleId(category, keyframeId)
}

export function videoInputPortKeyframeMiddle(entryId: string): string {
  return videoKeyframeMiddleHandleId(entryId)
}

export const VIDEO_ORIGINAL_PROMPT_SECTION_TESTID = 'video-overall-prompt-section'
